import Vue from '../main/vue';
import {history} from 'instantsearch.js/es/lib/routers';
import router from '../main/vue-routes';
import components from '../algolia';

const loadCompliantProducts = () => {
  if (document.querySelector('.compliant-products')) {
    const compliance = document.querySelector('.compliant-products')
      .dataset
      .compliance;

    new Vue({
      el: '.compliant-products',
      comments: true,
      components,
      data() {
        const indexName = this.$algolia.indexPrefix + 'products';

        const routing = {
          router: history(),
          stateMapping: {
            stateToRoute(uiState) {
              const indexUiState = uiState[indexName] || {};
              return {product_type: indexUiState.menu?.variation_type};
            },
            routeToState(routeState) {
              return {
                [indexName]: {
                  menu: {variation_type: routeState.product_type}
                }
              };
            }
          }
        };

        return {
          indexName,
          routing,
          filterString: `(variation_compliances_certifications:'${compliance}')`
        };
      },
      methods: {
        getProductLink(url) {
          const nsfFiltered = ['nsf-42', 'nsf-53', 'nsf-401'];
          if (nsfFiltered.includes(compliance.toLowerCase())) {
            return `${url}?variation_compliances_certifications=${compliance}&variation_filter_option=Filtered`;
          }

          return `${url}?variation_compliances_certifications=${compliance}`;
        }
      },
      router
    });
  }
};

export default loadCompliantProducts;
